/* shah */
import React from 'react'

const MuteIcon = () => {
    return (
        <svg id="SmallBoxSVG-mute" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1075 1024" className="icon" style={{display: "inline-flex"}}>
            <path xmlns="http://www.w3.org/2000/svg"
                d="M1051.064 14.996c19.999 19.995 19.999 52.413 0 72.408L774.62 363.852c-.026.021-.046.042-.067.063L313.825 824.642c-.026.031-.053.056-.079.082l-184.281 184.279c-19.995 19.994-52.413 19.994-72.408 0s-19.995-52.413 0-72.407l103.402-103.404c-15.655-8.755-26.239-25.498-26.239-44.713v-460.8c0-28.277 22.923-51.2 51.2-51.2h216.803L712.978 98.905a51.198 51.198 0 0 1 76.601 44.453v60.712L978.655 14.994c19.994-19.995 52.413-19.995 72.407 0zM687.181 306.472v-74.886L441.225 372.133a51.196 51.196 0 0 1-25.402 6.746h-179.2v358.4h19.752l430.806-430.808zm51.2 223.448c28.278 0 51.2 22.922 51.2 51.2V972.8a51.195 51.195 0 0 1-76.601 44.452l-241.921-138.24c-24.551-14.029-33.081-45.302-19.052-69.852 14.029-24.556 45.305-33.085 69.858-19.052l165.315 94.464V581.12c0-28.278 22.922-51.2 51.2-51.2z"></path>
        </svg>
    )
}

export default MuteIcon